import React, { useEffect, useState } from "react";
import { setCheckedItems } from "../redux/setItemsAction";
import { useDispatch, useSelector } from "react-redux";
import { currentDateFormat } from "../utils";
import axios from "axios";
import { GET_BILLING_INFO, BILLING_PROCESS } from "../constant";
import { setLoading } from "../redux/loaderAction";
import Swal from "../../node_modules/sweetalert2/dist/sweetalert2";
import { useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import { Base64 } from "js-base64";

function BillingSummary() {
  const navigate = useNavigate();
  const [currentDate, setCurrentDate] = useState(new Date());
  const [billingInfo, setBillingInfo] = useState([]);
  const [scheduleIds, setScheduleIds] = useState([]);
  const [isBillError, setIsBillError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const dispatch = useDispatch();
  var checkedItems = useSelector((state) => state.checkedItems);
  var totalAmount = 0;
  const displayedNames = new Set();
  useEffect(() => {
    dispatch(setLoading(true));

    axios
      .post(GET_BILLING_INFO, JSON.stringify(checkedItems), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        dispatch(setLoading(false));
        setBillingInfo(response.data);
        // Extract all schedule_id values from the response
        const extractedScheduleIds = response.data
          .map((item) => item.schedule_id)
          .filter((id) => id !== undefined && id !== null);
        setScheduleIds(extractedScheduleIds);
        //setFilteredScheduleList(response.data)
      })
      .catch((error) => {
        console.error(error);
      });
  }, [checkedItems, dispatch]);
  
  const billingProcess = async () => {
    try {
      setIsBillError(false);
      setErrorMessage("");
      setIsProcessing(true);
      dispatch(setLoading(true));
      const response = await axios.post(
        BILLING_PROCESS,
        { scheduleIds: checkedItems },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      dispatch(setLoading(false));
      setIsProcessing(false);
      if (response?.data?.status === "200") {
        const relativeFilePath = response?.data?.data?.split("responses")[1];
        navigate(`/home/billing/process?id=${Base64.encode(checkedItems)}`, {
          state: {
            filePath: response?.data?.data,
            jsonData: response?.data?.jsonData,
            scheduleIds: scheduleIds,
          },
        });
      } else if (
        response?.data?.status === "400" &&
        response?.data?.message === "Billing data validation failed"
      ) {
        console.log('billing validation data:',response?.data);
        console.log('billing validation failed:',response?.data?.message);
        setErrorMessage(
          "Billing validation failed. Please connect with administrator."
        );
        setIsBillError(true);
      } else if (response?.data?.status === "400") {
        Swal.fire({
          title: "Error!",
          text: response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        })
        // .then(() => {
        //   navigate("/home/billing/configuration");
        // });
      }
    } catch (error) {
      console.error("Error", error);
      dispatch(setLoading(false));
      setIsProcessing(false);

      // When API returns non-2xx HTTP status (like 400, 500), axios throws an error
      // The response data is available in error.response.data
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong";

      Swal.fire({
        title: "Error!",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <>
      <section>
        <div className="d-flex justify-content-between form-container">
          <div>
            <h2 className="fs-5 font-weight-600">Billing Summary </h2>
          </div>
          <div>
            <span>{currentDateFormat(currentDate)}</span>
          </div>
        </div>
      </section>
      {/* error message */}
      {isBillError && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <p style={{ color: "red" }}>{errorMessage}</p>
        </div>
      )}
      <section className="filter-section py-5">
        <table className="table border-0">
          <thead>
            {
              <>
                <div
                  style={{
                    display: "flex",
                    gap: "1rem",
                    justifyContent: "center",
                  }}
                >
                  <div>
                    <p className="billing-title">
                      Selected Passenger Information
                    </p>
                    {billingInfo.map((item, index) => {
                      totalAmount += item.bill_amount;
                      const passengerName = `${
                        item.passengerDetails?.firstName || ""
                      } ${item.passengerDetails?.middleName || ""} ${
                        item.passengerDetails?.lastName || ""
                      }`;
                      if (displayedNames.has(passengerName)) {
                        return null; // Skip rendering if the name is already displayed
                      }
                      displayedNames.add(passengerName);
                      return (
                        <React.Fragment key={index}>
                          <tr>
                            <td>{passengerName}</td>
                            {/* <td>Number of claim : {checkedItems.length}</td> */}
                          </tr>
                        </React.Fragment>
                      );
                    })}
                  </div>
                  <div>
                    <p className="billing-title">Selected Claim Information</p>
                    <div>Number of claim : {checkedItems.length}</div>
                    <div>Total amount : {totalAmount}</div>
                  </div>
                </div>
              </>
            }
          </thead>
        </table>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            style={{
              // width: "11em",
              // height: "30px",
              backgroundColor: "#328277",
              // backgroundColor: "#4d37bd",
              color: "#fff",
              border: "none",
            }}
            className="btn rounded-1"
            disabled={isBillError || isProcessing}
            onClick={billingProcess}
          >
            {isProcessing ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Processing...
              </>
            ) : (
              "CLICK HERE"
            )}
          </button>
        </div>
      </section>
    </>
  );
}

export default BillingSummary;
